
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'VulvarCancer_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/VulvarCancer_TNM.vue